export var OEM_TYPE = {
  GM: 'GM',
  OECONNECT: 'OECONNECT'
};
export var OEM_APPLICATION_TYPE = {
  GWM: 'GWM',
  VIUS: 'VIUS',
  PARTS: 'PARTS',
  PWB: 'PWB'
};